import { Button, Form, Grid, Input, Select } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AreaFilterFormField, AreaFilterFormValues } from './types';

const { useBreakpoint } = Grid;

type EventsFilterFormProps = {
  formId: string;
  handleFilter: (values: AreaFilterFormValues) => void;
  initialValues: AreaFilterFormValues;
  closeModal?: () => void;
};

export const AreaFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
}: EventsFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<AreaFilterFormValues>();
  const { t } = useTranslation();
  const screens = useBreakpoint();

  const onReset = () => {
    form.resetFields();
    handleFilter({...initialValues})
  };

  const handleOnFinish = (values: AreaFilterFormValues) => {
    handleFilter(values);
    closeModal?.();
  };
  const status = [
    {
      label: true,
      name: 'Active',
    },
    {
      label: false,
      name: 'InActive',
    },
  ];
  const status_value = status.map((res) => ({
    value: res.label,
    label: res.name,
  }));
  
  return (
    <Form<AreaFilterFormValues>
      id={formId}
      name={formId}
      form={form}
      layout='vertical'
      onFinish={handleOnFinish}
      initialValues={initialValues}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      validateTrigger={validateTrigger}
    >
      <ContentFilters.FormItemsWrapper style={{width:'100%'}}>
        <StandardItemsWrapper style={{width:'100%'}}>
          <div className='invoice_list' style={{width:'100%'}}>
          <Form.Item<AreaFilterFormValues>
            label={'Name'}
            name={AreaFilterFormField.Name}
          >
            <Input placeholder={'Enter area'} />
          </Form.Item>
          <Form.Item<AreaFilterFormValues>
            label={'Status'}
            name={AreaFilterFormField.ACTIVE}
          >
            <Select
              defaultValue="Select status"
             
              options={status_value}
            />
          </Form.Item>
          {screens.lg && (
        <ContentFilters.ButtonsWrapper className='filter_btn'>
          <Button type='primary' htmlType='submit'>
            {t('events.buttons.filter', { count: 1 })}
          </Button>
          <Button onClick={onReset}>{t('events.buttons.reset')}</Button>
        </ContentFilters.ButtonsWrapper>
      )}
          </div>
        </StandardItemsWrapper>
      </ContentFilters.FormItemsWrapper>

    
    </Form>
  );
};
